import { render, staticRenderFns } from "./UserSettings.vue?vue&type=template&id=6e822da8"
import script from "./UserSettings.ts?vue&type=script&lang=ts&external"
export * from "./UserSettings.ts?vue&type=script&lang=ts&external"
import style0 from "./UserSettings.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports